<template>
  <div
    :class="[
      {
        'ps-opacity-50': isPlaceholder
      },
      bgClass
    ]"
  >
    <div class="px-6 py-6 space-x-6">
      <div class="flex items-start">
        <div class="flex-shrink-0 pt-0.5">
          <user-avatar class="w-10 h-10" :user="comment.created_by_user" />
        </div>
        <div class="ml-3 w-0 flex-1">
          <p class="text-sm leading-5 font-medium text-gray-900">
            {{
              comment.created_by_user.provided_name ||
                comment.created_by_user.email
            }}
            <span class="ps-text-xxs ps-font-normal ps-ml-2 ps-gray-400"
              >{{ distanceToNow }} ago</span
            >
          </p>

          <div
            v-html="comment.text"
            class="mt-1 text-sm leading-5 text-gray-500 ps-whitespace-pre-wrap"
          >
            Sent you an invite to connect.
          </div>
          <div v-if="showReplyButton" class="mt-4 flex">
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                @click="$emit('reply')"
                class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white ps-bg-gray-600 hover:ps-bg-gray-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
              >
                Reply
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatar from '@/components/UserAvatar'

export default {
  name: 'ItemComment',
  props: {
    comment: {
      type: Object,
      default: () => {}
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    showReplyButton: {
      type: Boolean,
      default: false
    }
  },
  components: {
    UserAvatar
  },
  computed: {
    isPlaceholder() {
      return this.comment && this.comment.id === 'COMMENT_PLACEHOLDER'
    },
    distanceToNow() {
      if (this.comment && this.comment.created_at) {
        return this.comment.created_at.distance_to_now
      }
    },
    bgClass() {
      return `ps-bg-${this.bgColor}`
    }
  }
}
</script>
